import React, { Fragment } from "react";
import { useLanguages } from "../../vocabularyServices";
import { find, includes, is } from "ramda";
import { isBlank, notBlank } from "../../../util/ext";
import { prependEFIGS } from "../../../util/vocabUtils";

import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Skeleton from "@material-ui/lab/Skeleton";
import TextField from "@material-ui/core/TextField";
import { useIsIapReviewer } from "../../../auth/authUtils";

const LanguageSelect = props => {
  const {
    onBlur,
    onChange,
    value,
    required = false,
    error = false,
    helperText = "",
  } = props;
  const languages = useLanguages();
  const isIapReviewer = useIsIapReviewer();

  return (
    <Fragment>
      {languages.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <Autocomplete
            id="languages"
            value={value || ""}
            options={prependEFIGS(languages.data)}
            getOptionLabel={option => {
              if (isBlank(option)) {
                return "";
              } else if (is(Object, option)) {
                return option.displayName;
              } else {
                const lang = find(
                  l => includes(option, [l.id, l.name]),
                  languages.data,
                );
                return lang.displayName;
              }
            }}
            onChange={onChange}
            getOptionSelected={(lang, val) =>
              notBlank(val) && lang.id === val.id
            }
            renderInput={params => {
              params.inputProps["aria-autocomplete"] = "none";
              params.inputProps["id"] = "content-language";
              return (
                <TextField
                  {...params}
                  disabled={isIapReviewer}
                  required={required}
                  error={error}
                  type="text"
                  onBlur={onBlur}
                  name="content-language"
                  label="Language"
                  fullWidth
                />
              );
            }}
          />

          {notBlank(error) && (
            <FormHelperText error>{helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    </Fragment>
  );
};

export default LanguageSelect;
